import { createSelector } from '@reduxjs/toolkit';
import { Store } from 'components/common/types/Store.types';

export const getBackupLines = createSelector(
  (state: Store) => state.dealManagement.backupFormData.lines,
  (lines) => lines,
);
